/** Fixed tab order for map drawer tools (after Layers + Legend). */
export const TOOL_ORDER = [
  "draw",
  "print",
  "measure",
  "filter",
  "assetSearch",
  "query",
  "select",
  "bookmark",
  "direction",
];

export const BASE_DRAWER_TABS = 2;

export const TOOL_LABELS = {
  draw: "Draw",
  print: "Print",
  measure: "Measure",
  filter: "Filter",
  assetSearch: "Asset Search",
  query: "Query",
  select: "Select",
  bookmark: "Bookmark",
  direction: "Directions",
};

export function getToolTabIndex(activeTools, toolId, includePending = false) {
  const active = TOOL_ORDER.filter(
    (t) => activeTools.includes(t) || (includePending && t === toolId),
  );
  const idx = active.indexOf(toolId);
  return idx < 0 ? null : BASE_DRAWER_TABS + idx;
}

export function getToolIdFromTab(activeTab, activeTools) {
  if (activeTab < BASE_DRAWER_TABS) return null;
  const active = TOOL_ORDER.filter((t) => activeTools.includes(t));
  return active[activeTab - BASE_DRAWER_TABS] ?? null;
}

export function openToolState(activeTools, toolId) {
  const nextTools = activeTools.includes(toolId)
    ? activeTools
    : [...activeTools, toolId];
  const tabIndex = getToolTabIndex(nextTools, toolId);
  return { activeTools: nextTools, activeTab: tabIndex ?? BASE_DRAWER_TABS };
}

export function closeToolState(activeTools, toolId) {
  return {
    activeTools: activeTools.filter((t) => t !== toolId),
    activeTab: 0,
  };
}
